/**
 * Meeting writes — notes, items, recordings, the session's start and end, the standing summary — are
 * Manager-eligible (TMMAPI-0146, MM-D-115, superseding MM-D-32): the served `canManage` of the
 * meeting's virtual account (the owner or a Manager, guest seats included, the owner ACTIVE). Never
 * the invite list, never the caller's own tier.
 */
export function canWriteNotes(standing: { canManage: boolean } | null | undefined): boolean {
  return standing?.canManage === true;
}
